export default __webpack_public_path__ + "static/media/map-1.8eec7e36.webp";